var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('AppView',{attrs:{"id":"governance"}},[_c('h1',{staticStyle:{"margin-bottom":"20px"}},[_vm._v("Governance")]),_c('router-view')],1):_c('Loader')
}
var staticRenderFns = []

export { render, staticRenderFns }